import firebase from '../../lib/firebase.prod';
const firebaseRef = firebase.database();

export async function deleteRole(projectId, roleId) {
	if (!projectId) {
		return {
			success: false,
		};
	}
	if (!roleId) {
		return {
			success: false,
		};
	}

	let role = firebaseRef.ref('/kavtek_roles/' + projectId + '/' + roleId);
	role.remove();

	return {
		success: true,
	};
}
